import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pod",
  "use": "pod-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"pod\"><path d=\"M7 15h3v-3H7v3zm4-11l-7 6v8h7l7-6V4h-7zm5.5 7.31l-6.055 5.19H5.5v-5.81l6.055-5.19H16.5v5.81zM15 7h-3v3h3V7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol